export const truncateNumberAndRoundWithDecimals = (number: number, decimalPlaces = 1) => (Math.trunc(number * (10 ** decimalPlaces)) / 10 ** decimalPlaces).toFixed(decimalPlaces);
